module.exports = __webpack_public_path__ + "static/media/Jackpot_displayed_screen@3x.ce10f9df.png";